const React = require('react')
const PropTypes = require('prop-types')
const log = require('log').create('escape') // eslint-disable-line

let id = 0

class Escape extends React.Component {

    constructor() {
        super()
        this.cid = `escape${id++}`
    }

    componentDidMount() {
        this.listen()
    }

    componentWillUnmount() {
        this.unlisten()
    }

    listen() {
        this.escape = require('lib/escape')
        this.escape.listen(this.cid, this.props.onEscape)
    }

    unlisten() {
        this.escape.unlisten(this.cid)
    }

    render() {
        return null
    }

}
Escape.propTypes = {
    onEscape: PropTypes.func,
}

module.exports = Escape
